import { User, createState } from "@theprelude/core";
import SelectedUserOverlay from "./selected-user-overlay";

export const useSelectedUser = createState<User | null>(null);

export function UpdateUserOverlay() {
  const selectedUser = useSelectedUser();

  if (!selectedUser.value) {
    return null;
  }

  return (
    <SelectedUserOverlay
      onHide={() => selectedUser.setValue(null)}
      user={selectedUser.value}
    />
  );
}
